import { getActiveSubscriptions, clearSubscriptionCache as clearSharedCache } from './subscriptionCache';
import { subscriptionMatchesModuleTab } from './subscriptionModuleTabs';

/**
 * Snap Bill (invoice scanner) access control.
 * Module subscriptions are checked via active subscriptions, not task plan features.
 */

let invoiceScannerSubscriptionCache = null;
let invoiceScannerCacheTimestamp = null;
const CACHE_DURATION = 5 * 60 * 1000; // 5 minutes

const fetchInvoiceScannerSubscription = async () => {
  try {
    const response = await getActiveSubscriptions();

    if (response?.subscriptions?.length > 0) {
      const invoiceSub = response.subscriptions.find((sub) =>
        subscriptionMatchesModuleTab(sub, 'invoice_scanner')
      );

      if (invoiceSub) {
        return {
          id: invoiceSub.id,
          corporate_id: invoiceSub.corporate_id,
          subscription_plan_id: invoiceSub.subscription_plan_id,
          status: invoiceSub.status,
          SubscriptionPlan: invoiceSub.SubscriptionPlan,
        };
      }
    }

    return null;
  } catch (error) {
    console.error('Error fetching invoice scanner subscription:', error);
    return null;
  }
};

export const getInvoiceScannerSubscription = async () => {
  const now = Date.now();

  if (
    invoiceScannerSubscriptionCache &&
    invoiceScannerCacheTimestamp &&
    now - invoiceScannerCacheTimestamp < CACHE_DURATION
  ) {
    return invoiceScannerSubscriptionCache;
  }

  const subscription = await fetchInvoiceScannerSubscription();
  invoiceScannerSubscriptionCache = subscription;
  invoiceScannerCacheTimestamp = now;

  return subscription;
};

export const hasInvoiceScannerSubscription = async () => {
  try {
    const subscription = await getInvoiceScannerSubscription();
    return subscription !== null && subscription.status === 'active';
  } catch (error) {
    console.error('Error checking invoice scanner subscription:', error);
    return false;
  }
};

export const clearInvoiceScannerSubscriptionCache = () => {
  invoiceScannerSubscriptionCache = null;
  invoiceScannerCacheTimestamp = null;
  clearSharedCache();
};
